<template>
	<div
		class="bookmarks-dropdown-skeleton"
		:aria-label="$t('spa__general.loading')"
	>
		<SuiSkeleton width="90%" class="bookmarks-dropdown-skeleton__item" />
		<SuiSkeleton width="60%" class="bookmarks-dropdown-skeleton__item" />
		<SuiSkeleton width="70%" class="bookmarks-dropdown-skeleton__item" />
	</div>
</template>

<script setup lang="ts">
import { SuiSkeleton } from '@developers/scoro-ui';
</script>

<style lang="scss" scoped>
.bookmarks-dropdown-skeleton {
	padding: 0 2rem;

	&__item {
		height: 2rem;
		margin: 2.5rem 0;
	}
}
</style>
